import React, { Component } from "react"
import { BrowserRouter, Route } from "react-router-dom"

import Landing from "./Landing"
import TwoFAPage from "./TwoFAPage"
import Home from "./Home"
// import Bubbly from "./Bubbly"
// import FMD from "./fmd-website/FMD"
import DocScanQR from "./home/clients/client-forms/DocScanQR"
import SignaturePad from "./home/clients/client-forms/SignaturePad"

class ExternalRedirect extends Component {
    componentDidMount() {
        window.location.href = 'https://theaccountants.com.sg'
    }

    render() {
        return <div/>
    }
}

class App extends Component {
    render() {
        return (
            <div className="container"> 
                <BrowserRouter>
                    <div>
                        <Route exact path="/" component={ExternalRedirect} />
                        <Route exact path="/yttynnttdsht0268ws0501pls" component={Landing} />
                        <Route exact path="/yttynnttdsht0268ws0501pls/2fa" component={TwoFAPage} />
                        <Route exact path="/yttynnttdsht0268ws0501pls/home" component={Home} />
                        {/* <Route exact path="/bubbly" component={Bubbly} /> */}
                        {/* <Route exact path="/fmd" component={FMD} /> */}
                        <Route path="/scan_document/client/:clientID/record/:recordID/document/:docID" component={DocScanQR} />
                        <Route path="/client_e-signature/client/:clientID/record/:recordID" component={SignaturePad} />
                    </div>
                </BrowserRouter>
            </div>
        )
    } 
}

export default App
